// eslint-disable-next-line no-unused-vars
import { LatLng } from '../redux/type';
import { setMapStyle } from './mapStyle';

export const init2DMap = (
  centerPoint: LatLng,
  container: HTMLElement,
  zoom?: number
) => {
  const winAny = window as any;
  const { BMapGL } = winAny;
  if (!BMapGL) {
    return;
  }
  if (!centerPoint) {
    return;
  }

  // 手动将 GCJ02 转成 BD09 后传入，需要把全局 coordType 设为 BD09，
  // 否则 BMapGL.Point 会被默认按 GCJ02 解析导致二次偏移
  BMapGL.coordType = BMapGL.BMAP_COORD_BD09 ?? 5;
  const point = new BMapGL.Point(centerPoint.lon, centerPoint.lat);
  const map = new BMapGL.Map(container);
  map.centerAndZoom(point, zoom || 15);
  map.enableScrollWheelZoom();
  setMapStyle(map);

  // GL 版本使用百度底图，不再叠加 Google 瓦片
  return map;
};

// 腾讯地图初始化（供数据采集等仍需腾讯地图的模块使用）
export const initTencent2DMap = (
  centerPoint: LatLng,
  container: HTMLElement,
  zoom?: number
) => {
  const winAny = window as any;
  const { qq } = winAny;
  if (!qq) {
    return;
  }
  if (!centerPoint) {
    return;
  }

  const map = new qq.maps.Map(container, {
    center: centerPoint,
    zoom: zoom || 15,
    disableDefaultUI: true,
    mapStyleId: qq.maps.MapStyleId.DARK,
  });
  initGoogleMapForTencent(map);
  return map;
};

const initGoogleMapForTencent = (map: any) => {
  const winAny = window as any;
  const { qq } = winAny;

  const _getTileUrl = (tile: any, zoom: any) => {
    const x = tile.x;
    const y = tile.y;
    let tileUrl =
      'http://{s}.google.com/vt/lyrs=m@159000000&' +
      'hl=zh-CN&gl=en&x={x}&y={y}&z={z}&s=Gali';
    const tileSubdomains = ['mt0', 'mt1', 'mt2', 'mt3'];

    tileUrl = tileUrl.replace(/\{x\}/, x);
    tileUrl = tileUrl.replace(/\{y\}/, y);
    tileUrl = tileUrl.replace(/\{z\}/, zoom);

    const s = tileSubdomains[Math.floor(Math.random() * 4)];
    tileUrl = tileUrl.replace(/\{s\}/, s);

    return tileUrl;
  };

  const googleTileOpts = {
    alt: 'google',
    name: 'google',
    tileSize: new qq.maps.Size(256, 256),
    maxZoom: 19,
    minZoom: 1,
    getTileUrl: _getTileUrl,
  };
  const googleTile = new qq.maps.ImageMapType(googleTileOpts);
  map.mapTypes.set('google', googleTile);
};
